
import { ref, onMounted, onUnmounted, watch } from 'vue'

export default function useAutoCall(
  actions: any = [],
  turnOn: any,
  duration: number = 15000,
) {
  let count: any = ref(0)
  const caller = () => {
    count.value = setTimeout(() => {
      if (actions?.length) {
        actions.forEach((fn) => {
          fn?.()
        })
      }
      if (count.value !== 0) {
        caller()
      }
    }, duration)
  }

  const over = () => {
    clearTimeout(count.value)
    count.value = 0
  }

  watch(turnOn, val => {
    if (val) {
      caller()
    } else {
      clearTimeout(count.value)
    }
  })
  
  onMounted(() => {
    if (turnOn.value) {
      caller()
    }
  })

  onUnmounted(() => {
    over()
  })
}
